import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import { ReactComponent as ButtonLoading } from 'icons/loading2.svg'
import * as FA from 'react-icons/fa'
import { DateTime } from 'luxon'

import {
  Container,
  Row,
  InfoText,
  Button
} from './styles'

export default function DateReservation ({
  data: reservation,
  onEdit: handleEdit,
  onDelete: handleDelete
}) {
  const [showDeleteReservationDialog, setShowDeleteReservationDialog] = useState (false)
  const [deleting, setDeleting] = useState (false)
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const getPeriod = reservation => {
    const period = DateTime.fromISO (reservation.end_date)
      .diff (DateTime.fromISO (reservation.start_date), 'days').toObject ()

    return period.days > 0 ? `${period.days} dias` : '1 dia'
  }

  const period = getPeriod (reservation)

  const deleteReservation = async () => {
    try {
      setDeleting (true)
      await cutileiApi.delete (`/date_reservations/${reservation.id}`, requestConfig)
      handleDelete (reservation)
    } catch (error) {
      logApiError (error)
    } finally {
      setDeleting (false)
    }
  }

  const toggleDeleteReservationDialog = () => setShowDeleteReservationDialog (!showDeleteReservationDialog)

  return (
    <Container>
      <InfoText>
        {reservation.description}
      </InfoText>
      <InfoText>
        {DateTime.fromISO (reservation.start_date).toFormat ('dd/MM/yyyy')}
      </InfoText>
      <InfoText>
        {DateTime.fromISO (reservation.end_date).toFormat ('dd/MM/yyyy')}
      </InfoText>
      <InfoText>
        {period}
      </InfoText>
      <Row>
        {AuthService.hasPermission ('business_config.agenda', 'edit') && (
          <Button onClick={() => handleEdit (reservation)}>
            <FA.FaEdit color='#35A7FF' size={18}/>
          </Button>
        )}
        {AuthService.hasPermission ('business_config.agenda', 'delete') && (
          <Button onClick={toggleDeleteReservationDialog}>
            {deleting ? (
              <ButtonLoading style={{margin: 0}}/>
            ) : (
              <FA.FaTrash color='#FF3939' size={16}/>
            )}
          </Button>
        )}
      </Row>
      <AlertDialog
        visible={showDeleteReservationDialog}
        title='Atenção!'
        message='Deseja realmente excluir esta reserva?'
        confirmText='Sim'
        cancelText='Não'
        onConfirm={deleteReservation}
        onClose={toggleDeleteReservationDialog}
        dangerous={true}
      />
    </Container>
  )
}
